import React from "react";
import { Grid, Box, Typography, Avatar } from "@mui/material";
import { themes } from "../../themes/themes";

interface PropValue {
  name: string;
  designation: string;
  message: string;
  gift: string;
}
const AwardHistoryARTile = ({
  designation,
  gift,
  message,
  name,
}: PropValue) => {
  return (
    <Box
      style={{
        backgroundColor: "#F5F5FA66",
        height: "auto",
        padding: "1em",
        borderRadius: "10px",
        marginTop: "1em",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Typography
          style={{
            fontFamily: "Lato",
            color: themes.darkBlue,
            fontSize: "0.875em",
            fontWeight: "bold",
          }}
        >
          {name}
        </Typography>
        <Typography
          style={{
            fontFamily: "Lato",
            color: themes.grey_colorDesignationAR,
            fontSize: "0.75em",
            fontWeight: "bold",
          }}
        >
          {designation}
        </Typography>
        <Typography
          style={{
            fontFamily: "Lato",
            color: themes.greySubtitle,
            fontSize: "0.7em",
            fontWeight: "bold",
          }}
        >
          {message}
        </Typography>
      </Box>
      <Box
        style={{
          padding: "4px",
          backgroundColor: "#E6E8F0",
          borderRadius: "4px",
        }}
      >
        <Typography
          style={{
            color: themes.darkBlue,
            fontFamily: "Lato",
            fontSize: "0.7em",
            fontWeight: "bold",
            alignSelf: "center",
          }}
        >
          {gift}
        </Typography>
      </Box>
    </Box>
  );
};

export default AwardHistoryARTile;
